<script>

    import StatisticsQuotationsService from '../$services/statistics.quotations.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import Card from './component.quotations.card.svelte'

    export let dateStart = null
    export let dateEnd = null

    let summary = null
    let loading = false
    let error = false
    let seq = 0

    $: load(dateStart, dateEnd)

    $: metrics = summary ? [
        { label: 'Cotizaciones iniciadas', value: NumeralMethods.number(summary.total) },
        { label: 'Sin seleccionar servicio', value: NumeralMethods.number(summary.notSelected) },
        { label: 'Abandonos tras continuar', value: NumeralMethods.number(summary.abandoned) },
        { label: 'Guías generadas', value: NumeralMethods.number(summary.generated) },
        { label: 'Ventas potenciales sin guía', value: NumeralMethods.cashRound(summary.sales) },
        { label: 'Utilidad potencial sin guía', value: summary.profit === null ? '—' : NumeralMethods.cashRound(summary.profit) },
    ] : []

    async function load(start, end) {
        if (!start || !end) return

        const id = ++seq

        loading = true
        const res = await StatisticsQuotationsService.getSummary({
            dateStart: start.toISOString(),
            dateEnd: end.toISOString(),
        })

        // si el periodo cambió mientras cargaba, esta respuesta ya no aplica
        if (id !== seq) return

        loading = false
        error = !res?.success
        summary = res?.success ? res.data : null
    }

</script>

<style>
    .metrics {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1.6rem 1.5rem;
    }

    .metric-label {
        font-size: 0.88rem;
        color: #6b7280;
        margin: 0 0 0.3rem;
    }

    .metric-value {
        font-size: 1.6rem;
        font-weight: 700;
        color: #1a1a1a;
        line-height: 1.1;
        margin: 0;
        font-variant-numeric: tabular-nums;
    }

    .conversion {
        margin-top: 1.9rem;
    }

    .conversion-head {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        margin-bottom: 0.6rem;
    }

    .conversion-title {
        font-size: 1rem;
        font-weight: 700;
        color: #1a1a1a;
    }

    .conversion-value {
        font-size: 1.1rem;
        font-weight: 700;
        color: #1a1a1a;
        font-variant-numeric: tabular-nums;
    }

    .track {
        height: 0.9rem;
        background: #eef0f2;
        border-radius: 999px;
        overflow: hidden;
    }

    .fill {
        height: 100%;
        background: #098E37;
        border-radius: 999px;
    }

    .caption {
        margin: 0.6rem 0 0;
        font-size: 0.85rem;
        color: #6b7280;
    }
</style>

<Card title="Abandono de guías" { loading } { error }>
    {#if summary}
        <div class="metrics">
            {#each metrics as metric}
                <div>
                    <p class="metric-label">{ metric.label }</p>
                    <p class="metric-value">{ metric.value }</p>
                </div>
            {/each}
        </div>

        <div class="conversion">
            <div class="conversion-head">
                <span class="conversion-title">Conversión a guía</span>
                <span class="conversion-value">{ summary.conversion }%</span>
            </div>
            <div class="track">
                <div class="fill" style="width: { summary.conversion }%"></div>
            </div>
            <p class="caption">
                { NumeralMethods.number(summary.generated) } guías generadas de { NumeralMethods.number(summary.total) } procesos de cotización.
            </p>
        </div>
    {/if}
</Card>
